import React, { useState, useEffect } from 'react';
import { buildBackendImgUrl } from '../../utils/api'; // ajusta los ../ a tu estructura real

export default function SafeImg({ src, style, alt = '', loading, ...props }) {
  const [failed, setFailed] = useState(false);

  // Si cambia el src (otro trastero, nueva imagen subida), reintentamos cargar.
  useEffect(() => {
    setFailed(false);
  }, [src]);

  const finalSrc = buildBackendImgUrl(src);

  if (failed || !finalSrc) {
    return (
      <img src="/placeholder.jpg" alt="No disponible" style={{ ...style, objectFit: 'cover' }} />
    );
  }

  return (
    <img
      src={finalSrc}
      alt={alt}
      loading={loading}
      style={style}
      onError={() => {
        console.error('🔴 URL de imagen rota detectada por SafeImg:', finalSrc);
        setFailed(true);
      }}
      {...props}
    />
  );
}
